// pages/FAQ.jsx

import { useTranslation } from "react-i18next";

  
  const FAQ = () => {
    const { t } = useTranslation();
    const faqs = [
    {
      question: t("faqTitle1"),
      answer: t("faqDescription1"),
    },
    {
      question: t("faqTitle2"),
      answer: t("faqDescription2"),
    },
    {
      question: t("faqTitle3"),
      answer: t("faqDescription3"),
    },
  ];

    return (
      <section className="max-w-5xl mx-auto px-4 py-20 min-h-[100vh]">
      <h1 className="text-4xl font-bold text-center mb-12 text-[#42AB3F] ">
        {t("faqTitle")}
      </h1>
      <div className="space-y-8">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="bg-gray-50 dark:bg-white p-6 rounded-xl shadow 
            transform transition-transform duration-300 hover:scale-105"
          >
            <h2 className="text-lg font-semibold text-[#DA6E2f] mb-2">{faq.question}</h2>
            <p className="text-black dark:text-black">{faq.answer}</p>
          </div>
        ))}
      </div>
    </section>
    
    );
  };
  
  export default FAQ;
  